import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, SimpleChanges, forwardRef, Output, EventEmitter } from '@angular/core';
import { DialogConfig } from '../dialog/dialog-config';
import { BaseService } from '../../shared/services/base.service';
import { AlertsService } from '../../services/alerts.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
  standalone: false,
  providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VideoPlayerComponent),
            multi: true
        }
    ],
})
export class VideoPlayerComponent implements OnInit, AfterViewInit, OnDestroy {

  data: any;
  type: string = "video/mp4";
  src: any = "";
  videoMarkers: any[] = [];
  activeMarker: any = null;
    @Input() question: any;
    @Input('value') _value: any;
    @Input() disabled_: boolean = false;
    propagateChange = (_: any) => { };
    onTouched: any = () => { };
  @Input() videoId: string | undefined;
  safeVideoUrl!: SafeResourceUrl;

  @ViewChild('videoPlayer') videoPlayer!: ElementRef;
  hoverTime: number = 0;
  hoverPosition: number = 0;
  showHoverTime: boolean = false;
  currentTime: number = 0;
  videoDuration: number = 0;

  isClickedOpen: boolean = false;

  private timeUpdateHandler: any;  

  constructor(
    private dialogConfig: DialogConfig,
    private alerts: AlertsService,
    private baseService: BaseService,
    private sanitizer: DomSanitizer
  ) { }

  get value(): any {
    return this._value;
  }

  set value(val) {
      this._value = val;
      this.propagateChange(val);
      this.onTouched();
    }
  
    writeValue(value) {
      if (value != undefined || value != '') {
        this.value = value;
        this.setvalueForUpdate(this.value);
      } else {
        this.value = "";
      }
      this.propagateChange(value);
    }
  
    setvalueForUpdate(value) {
    }
    registerOnChange(fn: any) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }

  ngOnInit(): void {
    this.data = this.dialogConfig;
    this.getSourceUrl();

    this.refreshMarkers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoId']) {
      this.refreshMarkers();
    }
  }

  private refreshMarkers() {
    const markerId = this.videoId || this.data?.data?.item?.video_id || this.data?.data?.item?.id;
    if (markerId) {
      this.getVideoMarking(markerId);
    } else {
      this.videoMarkers = [];
    }
  }

  getVideoMarking(id: any) {
    let obj = { filter: 'video_id:' + id };

    this.baseService.getData(obj, '', 'video_marking', 'opsmgmt', 'GET_PAGE')
      .subscribe(res => {
        if (res && res.errCode === 0) {

          this.videoMarkers = (res.resource || []).map((item: any) => ({
            time: Number(item.video_time) || 0,
            text: item.video_text || '',
            description: item.description || item.video_description || item.desc || '',
            referenceCode: item.reference_code || item.referenceCode || item.ref_code || '',
            url: item.url || item.video_url || item.link || ''
          }));

        } else {
          this.alerts.error(res.message);
        }
      });
  }

  getSourceUrl() {
    if (this.data?.data?.item && this.data?.data?.action?.video_url_key) {
      this.src = this.data.data.item[this.data.data.action.video_url_key];

    }

    if (this.data?.data?.action?.popup?.type) {
      this.type = this.data.data.action.popup.type;
    }

  else {

    this.src = this._value;

    if (this.src && (this.src.includes('youtube') || this.src.includes('youtu.be'))) {
      this.type = 'youtube';

      const videoId = this.extractYouTubeVideoId(this.src);

      if (videoId) {
        const origin = encodeURIComponent(window.location.origin);
        const embedUrl = `https://www.youtube.com/embed/${videoId}?origin=${origin}`;
        this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
      }

    } else {
      this.type = 'video/mp4';
    }

  }
}

 extractYouTubeVideoId(url: string): string | null {
    const patterns = [
      /youtube\.com\/watch\?v=([^&]+)/,   // watch?v=
      /youtube\.com\/live\/([^?&]+)/,      // /live/
      /youtube\.com\/embed\/([^?&]+)/,     // /embed/
      /youtu\.be\/([^?&]+)/               // youtu.be short URL
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }

    return null;
  }

  seekTo(time: number) {
    const video = this.videoPlayer?.nativeElement;

    if (video) {
      if (video.readyState >= 1) {
        video.currentTime = time;
      } else {
        video.onloadedmetadata = () => {
          video.currentTime = time;
        };
      }

      video.play().catch(() => {});
    }
  }

  openMarker(marker: any, isClick: boolean = false) {
    this.activeMarker = marker;
    this.isClickedOpen = isClick;
  }

  closePopup() {
    if (!this.isClickedOpen) {
      this.activeMarker = null;
    }
  }

  forceClosePopup() {
    this.isClickedOpen = false;
    this.activeMarker = null;
  }

  ngAfterViewInit(): void {
    const video = this.videoPlayer?.nativeElement;

    if (video) {
      video.onloadedmetadata = () => {
        this.videoDuration = video.duration;
      };

      this.timeUpdateHandler = () => {
        this.currentTime = video.currentTime;
      };

      video.addEventListener('timeupdate', this.timeUpdateHandler);
    }
  }

  ngOnDestroy(): void {
    const video = this.videoPlayer?.nativeElement;

    if (video && this.timeUpdateHandler) {
      video.removeEventListener('timeupdate', this.timeUpdateHandler);
    }
  }

  onBarHover(event: MouseEvent) {
  const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
  const percent = (event.clientX - rect.left) / rect.width;

  this.hoverTime = percent * this.videoDuration;
  this.hoverPosition = percent * 100;
  this.showHoverTime = true;
}

onBarLeave() {
  this.showHoverTime = false;
}

  formatTime(seconds: number): string {
    if (seconds == null) return '0:00';

    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);

    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }
}